import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { CreateDisableForm, GeneratorEditForm, GeneratorEditSubmit } from './power-supply.model';

@Injectable({ providedIn: 'root' })
export class MessageService implements OnDestroy {
  public createDisableObj: CreateDisableForm = { createlocform: true };
  public generatorEditSaveEnabled$: Observable<GeneratorEditForm>;
  public messageGeneratorEditSave$: Observable<GeneratorEditSubmit>;
  public createSaveEnable$: Observable<CreateDisableForm>;
  submitObj = { issubmit: false };
  createsubmitObj = { iscreatesubmit: false };

  private messageSource = new BehaviorSubject(this.submitObj);
  currentMessage = this.messageSource.asObservable();
  
  disableObj = {locform:false};
  
  private messageSource_one = new BehaviorSubject(this.disableObj);
  editsaveEnabled = this.messageSource_one.asObservable();

  private messageSource_create = new BehaviorSubject(this.createsubmitObj);
  MessageCreateSave = this.messageSource_create.asObservable();

  // Generator Edit specific properties
  private generatorEditDisableObj: GeneratorEditForm = { generatorEditForm: true };
  private generatorEditSubmitObj: GeneratorEditSubmit = { isGeneratorEditSubmit: false };
  private messageSourceCreateDisable$: BehaviorSubject<CreateDisableForm>;
  private messageSourceGeneratorEdit$: BehaviorSubject<GeneratorEditSubmit>;
  private messageSourceGeneratorEditDisable$: BehaviorSubject<GeneratorEditForm>;

  public constructor() {
    this.messageSourceCreateDisable$ = new BehaviorSubject<CreateDisableForm>(this.createDisableObj);
    this.messageSourceGeneratorEdit$ = new BehaviorSubject<GeneratorEditSubmit>(this.generatorEditSubmitObj);
    this.messageSourceGeneratorEditDisable$ = new BehaviorSubject<GeneratorEditForm>(this.generatorEditDisableObj);
    this.createSaveEnable$ = this.messageSourceCreateDisable$.asObservable();
    this.messageGeneratorEditSave$ = this.messageSourceGeneratorEdit$.asObservable();
    this.generatorEditSaveEnabled$ = this.messageSourceGeneratorEditDisable$.asObservable();
  }
  changeMessage(key, value) {
    this.messageSource.next({ ...this.messageSource.value, [key]: value });
  }

  editsaveEnabledMessage(key, value) {
    this.messageSource_one.next({...this.messageSource_one.value, [key]: value });
  }

  saveMessageCreate(key, value) {
    this.messageSource_create.next({ ...this.messageSource_create.value, [key]: value });
  }

  createsave(key, value) {
    this.messageSourceCreateDisable$.next({ ...this.messageSourceCreateDisable$.value, [key]: value });
  }

  // Generator Edit specific methods
  public generatorEditSaveMessage(key: string, value: boolean): void {
    this.messageSourceGeneratorEdit$.next({ ...this.messageSourceGeneratorEdit$.value, [key]: value });
  }

  public generatorEditSaveEnabledMessage(key: string, value: boolean): void {
    this.messageSourceGeneratorEditDisable$.next({ ...this.messageSourceGeneratorEditDisable$.value, [key]: value });
  }

  public ngOnDestroy(): void {
    this.messageSourceCreateDisable$?.complete();
    this.messageSourceGeneratorEdit$?.complete();
    this.messageSourceGeneratorEditDisable$?.complete();
  }
}
